import { render, staticRenderFns } from "./ItemDespesa.vue?vue&type=template&id=39400b66"
import script from "./ItemDespesa.vue?vue&type=script&lang=js"
export * from "./ItemDespesa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports